import { useState, useEffect } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import "../styles/Formularios.css";
import InputGenerico from "./InputGenerico";
import InputSelectIp from "./InputSelectIp";
import InputInventario from "./InputInventario";
import InputSelectEstados from "./InputSelectEstados";
import InputSelectGenerico from "./InputSelectGenerico";
import { useApiFetch } from "../utils/apiFetch";
import InputUsuarioAutocomplete from "./InputUsuarioAutocomplete";

function RegistrarBienes() {
    const { setModuloActual, setSubModuloActual, logout } = useGlobal();
    const [serieBien, setSerieBien] = useState("");
    const [idIp, setIdIp] = useState("");
    const [idTipo, setIdTipo] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [marca, setMarca] = useState("");
    const [modelo, setModelo] = useState("");
    const [version_soft, setVersion_soft] = useState("");
    const [inventario, setInventario] = useState("");
    const [idEstado, setIdEstado] = useState("");
    const [idPropietario, setIdPropietario] = useState("");
    const [idResg, setIdResg] = useState("");
    const [idUso, setIdUso] = useState("");
    const [sameUser, setSameUser] = useState(false);
    const [mostrarBoton, setMostrarBoton] = useState(true);
    const apiFetch = useApiFetch();


    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        // Validaciones necesarias
        const serieTrim = (serieBien || "").trim();
        if (!serieTrim || serieTrim.length > 50) {
            setError("La serie debe tener máximo 50 caracteres y no puede estar vacía.");
            return;
        }

        if (!idEstado) {
            setError("Debe seleccionar un estado del bien.");
            return;
        }

        if (!idTipo) {
            setError("Debe seleccionar un tipo de bien.");
            return;
        }

        const marcaTrim = (marca || "").trim();
        if (!marcaTrim) {
            setError("Debe ingresar la marca del bien.");
            return;
        }

        const modeloTrim = (modelo || "").trim();
        if (!modeloTrim) {
            setError("Debe ingresar el modelo del bien.");
            return;
        }

        const version_softTrim = (version_soft || "").trim();
        if (!version_softTrim) {
            setError("Debe ingresar la versión de software.");
            return;
        }

        if (!idPropietario) {
            setError("Debe seleccionar un propietario.");
            return;
        }

        if (!idResg) {
            setError("Debe seleccionar un resguardante.");
            return;
        }

        if (!sameUser && !idUso) {
            setError("Debe seleccionar un operador.");
            return;
        }

        const inventarioTrim = (inventario || "").trim();
        if (idPropietario === 1 && !inventarioTrim) {
            setError("El inventario es obligatorio para bienes SICT.");
            return;
        }

        // Si pasa todas las validaciones, continuar con el fetch
        setLoading(true);
        try {
            const data = await apiFetch("registrar_bienes.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    serie_bien: serieTrim,
                    id_ip: idIp || null,
                    id_tipo: idTipo,
                    marca: marcaTrim,
                    modelo: modeloTrim,
                    version_soft: version_softTrim,
                    inventario: inventarioTrim || null,
                    id_estado: idEstado || null,
                    id_propietario: idPropietario || null,
                    id_resg: idResg || null,
                    id_uso: sameUser ? idResg : (idUso || null)
                })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Bien registrado correctamente.");
                setTimeout(() => {
                    setModuloActual("Hardware");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setError(data.message || "\u274C No se pudo registrar el bien.");
            }
        } catch {
            setError("\u26A0 Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    // Limpiar mensajes después de 3 segundos
    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(""), 3000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    useEffect(() => {
        if (success) {
            const timer = setTimeout(() => setSuccess(""), 3000);
            return () => clearTimeout(timer);
        }
    }, [success]);


    return (
        <div className="sesion-form">

            {error && <div className="error">{error}</div>}
            {success && <div className="success">{success}</div>}

            <form onSubmit={onSubmit}>
                <InputGenerico
                    value={serieBien}
                    setValue={setSerieBien}
                    label="Serie del bien"
                    maxLength={30}
                    allowedChars="A-Z0-9/_\-"
                    transform="uppercase"
                    placeholder="MXL1234ABC"
                    title="Máximo 30 caracteres"
                />

                <InputSelectEstados
                    idEstado={idEstado}
                    setIdEstado={setIdEstado}
                    estadoActualText=""
                    idEntidad={1}
                    label="Estado del bien"
                />

                {/* Condición para aprovechar recursos IP */}
                {(idEstado === 1 || idEstado === 2 || idEstado === 4) && (
                    <InputSelectIp
                        idIp={idIp}
                        setIdIp={setIdIp}
                        estadoFiltro="DISPONIBLE"
                        label="Asignar IP disponible"
                    />
                )}

                <InputSelectGenerico
                    idSeleccionado={idTipo}
                    setIdSeleccionado={setIdTipo}
                    label="Tipo de bien"
                    apiUrl={`consultar_tipo_bienes.php`}
                    valueField="id_tipo"
                    displayField="tipo_bien"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione un tipo"
                />

                <InputGenerico
                    value={marca}
                    setValue={setMarca}
                    label="Marca"
                    maxLength={50}
                    allowedChars="A-Z0-9/_\- "
                    transform="uppercase"
                    placeholder="HP"
                    title="Máximo 50 caracteres"
                />

                <InputGenerico
                    value={modelo}
                    setValue={setModelo}
                    label="Modelo"
                    maxLength={50}
                    allowedChars="A-Z0-9/_\- "
                    transform="uppercase"
                    placeholder="PRODESK 700"
                    title="Máximo 50 caracteres"
                />

                <InputGenerico
                    value={version_soft}
                    setValue={setVersion_soft}
                    label="Versión software"
                    maxLength={50}
                    allowedChars="A-Z0-9/_\- "
                    transform="uppercase"
                    placeholder="WINDOWS 11 N/A"
                    title="Máximo 50 caracteres"
                />

                <InputSelectGenerico
                    idSeleccionado={idPropietario}
                    setIdSeleccionado={setIdPropietario}
                    label="Propietario"
                    apiUrl={`consultar_propietarios.php`}
                    valueField="id_propietario"
                    displayField="propietario"
                    readOnly={false}
                    showDefaultOption={true}
                    defaultOptionText="Seleccione el propietario"
                />

                {/* Solo bienes SICT llevan inventario */}
                {idPropietario === "1" && (
                    < InputInventario
                        inventario={inventario}
                        setInventario={setInventario}
                    />
                )}

                < InputUsuarioAutocomplete
                    idSeleccionado={idResg}
                    setIdSeleccionado={setIdResg}
                    label="Resguardante"
                    placeholder="Ingrese apellido paterno"
                    title="Seleccione al usuario resguardante"
                    readOnly={false}
                    maxLength={50}
                />

                <div className="form-group">
                    <label>
                        <input
                            type="checkbox"
                            checked={sameUser}
                            onChange={(e) => setSameUser(e.target.checked)}
                        />
                        El resguardante opera el equipo
                    </label>
                </div>

                {!sameUser && (
                    < InputUsuarioAutocomplete
                        idSeleccionado={idUso}
                        setIdSeleccionado={setIdUso}
                        label="Operador"
                        placeholder="Ingrese apellido paterno"
                        title="Seleccione al usuario operador"
                        readOnly={false}
                        maxLength={50}
                    />
                )}

                <div className="form-buttons">
                    {mostrarBoton && (
                        <button className="btn" type="submit" disabled={loading}>
                            {loading ? "Registrando..." : "Registrar"}
                        </button>
                    )}
                </div>

            </form>
        </div>
    );
}

export default RegistrarBienes;